module.exports = __webpack_public_path__ + "img/hero_.f2b8554c.png";